module.exports = __webpack_public_path__ + "static/coach-blue-blur-caf7adfcb23b581eaf97ea14ef903089.jpg";